/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Txt_VerifyInputs */

const en_txt_verify = /** @type {(inputs: Txt_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TXT (Verify):`)
};

const es_txt_verify = /** @type {(inputs: Txt_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TXT (Verificar):`)
};

const fr_txt_verify = /** @type {(inputs: Txt_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TXT (Vérification) :`)
};

const de_txt_verify = /** @type {(inputs: Txt_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TXT (Überprüfen):`)
};

const ja_txt_verify = /** @type {(inputs: Txt_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TXT (検証):`)
};

const zh_txt_verify = /** @type {(inputs: Txt_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TXT (验证)：`)
};

const ar_txt_verify = /** @type {(inputs: Txt_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجل TXT (للتحقق):`)
};

const id_txt_verify = /** @type {(inputs: Txt_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TXT (Verifikasi):`)
};

const it_txt_verify = /** @type {(inputs: Txt_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TXT (Verifica):`)
};

const ru_txt_verify = /** @type {(inputs: Txt_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TXT (Верификация):`)
};

const pt_txt_verify = /** @type {(inputs: Txt_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TXT (Verificar):`)
};

const ko_txt_verify = /** @type {(inputs: Txt_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TXT (검증):`)
};

/**
* | output |
* | --- |
* | "TXT (Verify):" |
*
* @param {Txt_VerifyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const txt_verify = /** @type {((inputs?: Txt_VerifyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Txt_VerifyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_txt_verify(inputs)
	if (locale === "es") return es_txt_verify(inputs)
	if (locale === "fr") return fr_txt_verify(inputs)
	if (locale === "de") return de_txt_verify(inputs)
	if (locale === "ja") return ja_txt_verify(inputs)
	if (locale === "zh") return zh_txt_verify(inputs)
	if (locale === "ar") return ar_txt_verify(inputs)
	if (locale === "id") return id_txt_verify(inputs)
	if (locale === "it") return it_txt_verify(inputs)
	if (locale === "ru") return ru_txt_verify(inputs)
	if (locale === "pt") return pt_txt_verify(inputs)
	return ko_txt_verify(inputs)
});